<template>
  <div class='h-nomargin h-track-flexContent h-track-flexColumn h100'>
    <div class='h-normalBg h-track-padding15 h-track-flexItem h-scroll'>
      <ejs-treeview v-show='!textShow' :fields='treeSetting'></ejs-treeview>
      <div v-show='textShow' v-html='textHtml'></div>
    </div>
    <div class='h-normalBg h-track-padding15 h-track-h25rem h-track-border h-scroll'>{{ json }}</div>
  </div>
</template>
<script>
export default {
  name: 'ImportJsonTree',
  data() {
    return {
      json: '',
      textShow: false,
      textHtml: '',
      treeSetting: {
        dataSource: [],
        id: 'id',
        text: 'text',
        child: 'children'
      }
    };
  },
  methods: {
    toCodeArray(data) {
      const arr = [];
      for (let i = 0; i < data.length / 2; i++) {
        arr[i] = data.substring(2 * i, 2 * i + 2);
      }
      return arr.toString().replace(/,/g, ' ');
    },
    showText(objs) {
      const reg = /\n/,
        blank = /\s/g,
        lt = /</g,
        gt = />/g;
      let texts = [];
      let html = '';
      if (objs && objs.constructor === String) {
        texts = objs.split(reg);
      }
      for (let i = 0; i < texts.length; i++) {
        if (texts[i]) {
          let temp = texts[i].replace(blank, '&nbsp;&nbsp;');
          temp = temp.replace(lt, '&lt;');
          temp = temp.replace(gt, '&gt;');
          html += `<span>${temp}</span>`;
        }
      }
      return html;
    },
    loadData(data) {
      const This = this;
      This.json = `${This.toCodeArray(data.message)}`;
      console.log(data.text, data.asn, data.pri);
      this.textShow = false;
      if (data.text) {
        this.textShow = true;
        this.textHtml = this.showText(data.text);
        console.log(this.showText(data.text));
      } else if (data.asn) {
        This.treeSetting = {
          dataSource: data.asn,
          id: 'id',
          text: 'text',
          child: 'children'
        };
      } else {
        This.treeSetting = {
          dataSource: data.pri,
          id: 'id',
          text: 'text',
          child: 'children'
        };
      }
    }
  }
};
</script>